import { MDXRemote } from 'next-mdx-remote';

import { blogMdxComponents } from 'components/blog/blog-mdx-components';

const BlogContentSection = ({ article }) => {
	// Render
	return (
		<div className='prose-editorial pb-4'>
			<MDXRemote {...article.content} components={blogMdxComponents} />
		</div>
	);
};

export { BlogContentSection };
